import React from "react";
import AppModal from "../common/AppModal";
import CreateOrUpdateItemForm from "../../forms/CreateOrUpdateItemForm";
import { ItemResponseDto } from "../../shared/dtos/item/ItemResponseDto";

interface UpdateItemModalProps {
  open: boolean;
  onClose: () => void;
  item: ItemResponseDto;
  loading: boolean;
  error: string | null;
}

const UpdateItemModal: React.FC<UpdateItemModalProps> = ({
  open,
  onClose,
  item,
  loading,
  error,
}) => (
  <AppModal
    open={open}
    onClose={onClose}
    title={`Edit: ${item.name}`}
    width="md"
    loading={loading}
  >
    <CreateOrUpdateItemForm
      isEditing={true}
      item={item}
      loading={loading}
      error={error}
    />
  </AppModal>
);

export default UpdateItemModal;
